import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  Divider,
  CircularProgress,
  Box,
  Stack,
  useTheme
} from "@mui/material";
import { fetchOfferById } from "../../../../services/pos/Tables";

const ViewOfferModal = ({ offerId, isOpen, onClose }) => {
  const theme = useTheme();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !offerId) return;
    const loadData = async () => {
      setLoading(true);
      try {
        const res = await fetchOfferById(offerId);
        setData(res.data);
      } catch (err) {
        alert("❌ " + err.message);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [isOpen, offerId]);

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>تفاصيل العرض</DialogTitle>
      <DialogContent sx={{ bgcolor: theme.palette.background.default }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={3}><CircularProgress /></Box>
        ) : data ? (
          <Stack spacing={1}>
            <Typography variant="h6">{data.name}</Typography>
            <Typography variant="subtitle2">{data.name_tag}</Typography>
            <Typography variant="body2" color="text.secondary" fontStyle="italic">{data.description}</Typography>

            <Divider sx={{ my: 1 }} />

            <Typography variant="body2">الحالة: {data.status === "active" ? "✅ نشط" : "❌ غير نشط"}</Typography>
            <Typography variant="body2">📅 {new Date(data.start_date).toLocaleDateString()} → {new Date(data.end_date).toLocaleDateString()}</Typography>
            <Typography variant="body2">🏷️ الخصم: {data.discount} جنيه</Typography>
            <Typography variant="body2">📦 عدد المنتجات: {data.items_number}</Typography>
            <Typography variant="body2">💰 السعر الإجمالي: {data.total_price} جنيه</Typography>

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle2" fontWeight="bold">🛒 تفاصيل المنتجات:</Typography>
            {Array.isArray(data.items) && data.items.map((item, idx) => (
              <Box key={idx} display="flex" alignItems="center" gap={2} my={1}>
                {item.product_image && (
                  <img
                    src={`https://${window.location.hostname}/${item.product_image}`}
                    alt="product"
                    style={{ width: 60, height: 60, borderRadius: 4, objectFit: "cover" }}
                  />
                )}
                <Typography variant="body2">
                  ▸ {item.product_name} | 💵 {item.price} | 🔢 {item.quantity} | 📝 {item.note || "—"}
                </Typography>
              </Box>
            ))}

            <Divider sx={{ my: 1 }} />

            <Typography variant="subtitle2" fontWeight="bold">🏢 الفروع المرتبطة:</Typography>
            {Array.isArray(data.roots) && data.roots.map((r) => (
              <Typography key={r.id} variant="body2">- {r.name}</Typography>
            ))}
          </Stack>
        ) : (
          <DialogContentText>لا توجد بيانات</DialogContentText>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewOfferModal;